class GPSwimwearPdpLinkedColors extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-swim-mode]'));
    this.views = Array.from(this.querySelectorAll('[data-swim-view]'));
    this.mode = this.dataset.defaultMode === '2' ? 'inside' : 'outside';

    this.buttons.forEach((button) => button.addEventListener('click', this.handleModeChange));
    this.syncMode();

    // Warm hidden views near the viewport, before a shopper presses the toggle.
    if ('IntersectionObserver' in window) {
      this.preloadObserver = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.preloadViews();
        this.preloadObserver.disconnect();
      }, { rootMargin: '600px' });
      this.preloadObserver.observe(this.querySelector('.gp-swimwear-pdp__links') || this);
    } else {
      this.preloadViews();
    }
  }

  disconnectedCallback() {
    this.buttons?.forEach((button) => button.removeEventListener('click', this.handleModeChange));
    this.preloadObserver?.disconnect();
  }

  preloadViews() {
    this.views?.forEach((view) => {
      view.querySelectorAll('img').forEach((image) => {
        image.fetchPriority = 'low';
        image.loading = 'eager';
        image.decode().catch(() => {});
      });
    });
  }

  handleModeChange = (event) => {
    const mode = event.currentTarget?.dataset?.swimMode;
    if (mode !== 'outside' && mode !== 'inside') return;

    this.mode = mode;
    this.syncMode();
  };

  syncMode() {
    this.buttons?.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.swimMode === this.mode));
    });

    this.views?.forEach((view) => {
      view.hidden = view.dataset.swimView !== this.mode;
    });
  }
}

if (!customElements.get('gp-swimwear-pdp-linked-colors')) {
  customElements.define('gp-swimwear-pdp-linked-colors', GPSwimwearPdpLinkedColors);
}
